// Typed wrappers for /api/v2/admin/payments/pending/*.
// Note: endpoints not yet in openapi.yaml; use shared adminFetch for CSRF/renew safety.
// Simplificação operador 10/07/2026: a fila só tem UMA ação (liberar com
// plano) — review/comentários/detalhe saíram da superfície.
import { adminFetch, jsonRequest } from "@/lib/api/admin-fetch";

// Local types until admin/payments endpoints are added to openapi.yaml.
export interface PendingPaymentRow {
  id: string;
  email: string;
  provider: string;
  providerPaymentId: string | null;
  amountCents: number;
  errorReason: string;
  createdAt: string;
  // Redesign 09/07/2026: link direto pro perfil.
  userId?: string | null;
}
// Fila de auto-liberação 0053 (30/07/2026): pagamento pago aguardando o
// delay do plano vencer — sem ação manual, só countdown até releaseAt.
export interface ScheduledReleaseRow {
  id: string;
  email: string;
  offerHash: string | null;
  planId: string | null;
  amountCents: number;
  releaseAt: string;
  createdAt: string;
}
export interface PendingPaymentList {
  items: PendingPaymentRow[];
  /** Só vem na primeira página (offset 0) — faixa informativa. */
  scheduled?: ScheduledReleaseRow[];
  total: number;
  limit: number;
  offset: number;
}
export interface OkResult {
  ok: boolean;
}
export interface ResolvePayload {
  plan_id: string;
  subscription_id?: string;
}

export type ListPendingParams = {
  limit?: number;
  offset?: number;
  /** Busca por e-mail (ILIKE no backend) — redesign 09/07/2026. */
  q?: string;
};

export async function fetchPendingPayments(
  params: ListPendingParams,
): Promise<PendingPaymentList> {
  const search = new URLSearchParams();
  if (params.limit != null) search.set("limit", String(params.limit));
  if (params.offset != null) search.set("offset", String(params.offset));
  if (params.q) search.set("q", params.q);
  return adminFetch<PendingPaymentList>(
    `/api/v2/admin/payments/pending?${search}`,
  );
}

export async function resolvePayment(
  renewalId: string,
  body: ResolvePayload,
): Promise<OkResult> {
  return adminFetch<OkResult>(
    `/api/v2/admin/payments/pending/${renewalId}/resolve`,
    jsonRequest("POST", body),
  );
}
